import React from 'react';
import { Card, Typography, Space, Tag, Divider, Collapse } from 'antd';
import { QuestionCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;
const { Panel } = Collapse;

const FAQ: React.FC = () => {
  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div>
            <Title level={3}>
              <QuestionCircleOutlined style={{ marginRight: 8 }} />
              Frequently Asked Questions
            </Title>
            <Tag color="green">Upcoming Feature</Tag>
          </div>
          
          <Divider />
          
          <div>
            <Title level={4}>Common Questions</Title>
            <Paragraph>
              This page will contain frequently asked questions and their answers.
              Features will include:
            </Paragraph>
            
            <Collapse defaultActiveKey={['1']} ghost>
              <Panel header="How to get started with the system?" key="1">
                <Text>Detailed guide on setting up your account and getting familiar with the platform.</Text>
              </Panel>
              <Panel header="How to manage appointments?" key="2">
                <Text>Step-by-step instructions for creating, editing, and managing appointments.</Text>
              </Panel>
              <Panel header="How to generate reports?" key="3">
                <Text>Guide on accessing and customizing various reports and analytics.</Text>
              </Panel>
              <Panel header="How to manage user permissions?" key="4">
                <Text>Instructions for setting up and managing user roles and access levels.</Text>
              </Panel>
            </Collapse>
          </div>
          
          <div style={{ 
            background: '#f6ffed', 
            padding: '16px', 
            borderRadius: '8px',
            border: '1px solid #b7eb8f'
          }}>
            <Space>
              <InfoCircleOutlined style={{ color: '#52c41a' }} />
              <Text type="secondary">
                Comprehensive FAQ section will be available to help answer common questions quickly.
              </Text>
            </Space>
          </div>
        </Space>
      </Card>
    </div>
  );
};

export default FAQ;
